module.exports = __webpack_public_path__ + "img/cn_2.252ce8ac.jpg";